import React  from 'react'

import Modal from "react-modal";
import "../../Modais/css/Modais.css";
import "../../Modais/css/ModaisMobile.css";
import "../../Modais/css/Images.css";

export default function ModalHistoricoConsumo({ isOpenHistoricoConsumo, onRequestCloseModal }) {


  return (
  <Modal
    isOpen={isOpenHistoricoConsumo}
    onRequestClose={onRequestCloseModal}
    contentLabel="Modal"
    style={{ outline: 0 }}
    ariaHideApp={false}
    className={{
      base: "modal-base-historico-consumo",
      afterOpen: "modal-base_after-open",
      beforeClose: "modal-base_before-close"
    }}
    overlayClassName={{
      base: "overlay-base",
      afterOpen: "overlay-base_after-open",
      beforeClose: "overlay-base_before-close"
    }}
    shouldCloseOnOverlayClick={true}
  >

  <div className="modal-close"  onClick={onRequestCloseModal}></div>
  <div className='modal-historico-consumo'>
    <div className='modal-historico-title'>Agora, precisamos do seu <b>histórico de consumo, em kWh.</b></div>
    <div className='modal-historico-text'>Esteja com a fatura da sua distribuidora local em mãos e busque por este quadro de informações abaixo. Geralmente, você o encontra no canto inferior esquerdo da fatura</div>
  </div>
   <button className="button-modal-historico-consumo" onClick={onRequestCloseModal}  id="btnHistNext">Vamos lá!</button>

  </Modal>
  )
}